/**
 * created by wang lei
 拆分成行 页面
 *
 */
import React, {Component} from 'react';
import splitRows from './splitRows.png';
import {EDITOR_TOOL_BTN_COLOR} from "../../../../../constants";

export default class SplitRowsTool extends Component {
    constructor(props) {
        super(props);
        this.state = {
            splitRows:false
        }

    }
    /**
     * 监听内容变化
     */
    listenContentChange(){
        let splitRows = this.props.editor.queryCommandState("splittorows")
        this.setState({splitRows: splitRows === 0});
    }

    /**
     * 监听编辑器点
     */
    listenContentClick(){
        let splitRows = this.props.editor.queryCommandState("splittorows")
        this.setState({splitRows: splitRows === 0});
    }

    render() {
        return (
            <span style={{cursor:"pointer",opacity:this.state.splitRows ? "1":"0.3"}}>
                <img className={"editor-splittoRows-tool-btn"} src={splitRows}
                     onClick={()=>this.props.editor.execCommand("splittorows")}/>
                {this.state.splitRows ? <style>{`
                .editor-splittoRows-tool-btn{
                    border: 1px solid #f2f6fc
                }
                .editor-splittoRows-tool-btn:hover{
                    border: 1px solid ${EDITOR_TOOL_BTN_COLOR.hover}
                }
                .editor-splittoRows-tool-btn:active{
                    border: 1px solid ${EDITOR_TOOL_BTN_COLOR.press}
                }
            `}</style> : <style>{`
                .editor-splittoRows-tool-btn{
                    border: 1px solid #f2f6fc
                }
                .editor-splittoRows-tool-btn:hover{
                    border: 1px solid transparent
                }
                .editor-splittoRows-tool-btn:active{
                    border: 1px solid transparent
                }
            `}</style>}

            </span>
        )
    }

}